export default __webpack_public_path__ + "static/media/26.81b5e9e9.png";